export type MyStateResponseTimeStamp = string;

type AccountId = string;

export class TransactionCheckHelper {
    latestAccountTransactions: Record<AccountId, MyStateResponseTimeStamp>;

    isChecking: boolean;

    syncCheckId: NodeJS.Timeout | null;

    constructor() {
        this.latestAccountTransactions = {};
        this.isChecking = false;
        this.syncCheckId = null;
    }
}
